export enum LANGUAGES {
    PL = "pl",
    FR = "fr",
}
